<script setup lang="ts">
import { PresetHelper } from "@/helpers/preset.helper";
import Toast, { type ToastProps } from "primevue/toast";

export interface TaiToastProps extends ToastProps {}

defineProps<TaiToastProps>();

const { preset } = new PresetHelper({
  classMap: {},
  preset: {}
});
</script>

<template>
  <Toast
    data-testid="tai-toast"
    v-bind="{ ...$props, ...$attrs }"
    :pt="preset"
    :pt-options="{ mergeProps: true }"
    unstyled
  ></Toast>
</template>
